import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";

function PoslovniSubjektIcon(props) {
  return <TrendingUpIcon {...props}/>;
}

export default PoslovniSubjektIcon;
